/**
 * Created by Victor Rojo on 30/8/19.
 */
export class Tag{
  constructor(
    public id: {
      tagKey: string,
      cloudAccountId: string
    },
    public colour: number,
    public priority: number,
    public iPlaceFlag: string,
    public widgetFlag: number,
    public gadgetFlag: number
  ){}
}

export const ItemTagType = {
  IPLACE: 1,
  WIDGET: 2,
  GADGET: 3
};

export class ItemTag{
  constructor(
    public id: {
      tagKey: string,
      cloudAccountId: string,
      itemType: number,
      itemId: string
    },
    public itemTagOrder: number,
    public active: boolean,
    public updated: boolean
  ){}
}
